angular.module('impactx.basket').controller('BasketChangeNameCtrl',  ['$scope', '$mdDialog', 'id', 'dataGen', BasketChangeNameCtrl]);

function BasketChangeNameCtrl($scope, $mdDialog, id, dataGen)
{
    var self = this;

    dataGen.getData($scope, {id: id},"/basket/menu/template/renamedata");

    this.saveName = function()
    {
        var dataObj = {
            id: id,
            newName: $scope.data.name.value
        };
        dataGen.postAsForm({}, dataObj, "/basket/menu/template/saverenamedata").then(function()
        {
            $mdDialog.hide();
        });
    };

    this.cancel  = function ()
    {
        $mdDialog.cancel();
    };
    $scope.test = "Hallo" + id;
}